import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { CalcScreen, CategoryCard } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

const FUMEHOOD_CATEGORIES = [
  {
    title: 'Types',
    description: 'Standard, high performance, radioisotope, and perchloric acid fume hoods',
    emoji: '🔬',
    screen: 'FumehoodTypes',
  },
  {
    title: 'Calculations',
    description: 'Face velocity, CFM, face area, and pressure differential calculations',
    emoji: '🧮',
    screen: 'FumehoodCalculations',
  },
];

const FumehoodOverviewScreen = () => {
  const navigation = useNavigation();

  return (
    <CalcScreen
      title="Fume Hood Testing"
      subtitle="Fume hood measurements and calculations"
    >
      <Text style={styles.sectionLabel}>Categories</Text>
      {FUMEHOOD_CATEGORIES.map((category) => (
        <CategoryCard
          key={category.screen}
          emoji={category.emoji}
          title={category.title}
          description={category.description}
          cta={`View ${category.title} →`}
          onPress={() => navigation.navigate(category.screen as never)}
        />
      ))}
    </CalcScreen>
  );
};

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});

export default FumehoodOverviewScreen;
